"use client";

import React from "react";
import EditSection, { TextEditor } from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function CollegeHeroEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const updateContent = (key: string, value: any) => {
    onContentChange?.({ ...content, [key]: value });
  };

  return (
    <EditSection
      content={content}
      onContentChange={onContentChange || (() => {})}
      contentFields={
        <div className="space-y-4">
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Hero Headers</h4>
            <TextEditor
              label="Tag / Label"
              value={content.tag}
              onChange={(v) => updateContent("tag", v)}
              placeholder="Welcome to our College"
            />
            <TextEditor
              label="Title"
              value={content.title}
              onChange={(v) => updateContent("title", v)}
              placeholder="Shaping Tomorrow's Leaders"
            />
            <TextEditor
              label="Subtitle / Description"
              value={content.subtitle}
              onChange={(v) => updateContent("subtitle", v)}
              placeholder="World-class education combined with..."
              multiline
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Primary CTA</h4>
            <TextEditor
              label="Button Text"
              value={content.primaryCta}
              onChange={(v) => updateContent("primaryCta", v)}
              placeholder="Explore Programs"
            />
            <TextEditor
              label="Button Link"
              value={content.primaryBtnLink}
              onChange={(v) => updateContent("primaryBtnLink", v)}
              placeholder="#explore"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Secondary CTA</h4>
            <TextEditor
              label="Button Text"
              value={content.secondaryCta}
              onChange={(v) => updateContent("secondaryCta", v)}
              placeholder="Schedule a Visit"
            />
            <TextEditor
              label="Button Link"
              value={content.secondaryBtnLink}
              onChange={(v) => updateContent("secondaryBtnLink", v)}
              placeholder="#visit"
            />
          </div>

          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">Media</h4>
            <TextEditor
              label="Image URL"
              value={content.imageUrl}
              onChange={(v) => updateContent("imageUrl", v)}
              placeholder="https://images.unsplash.com/..."
            />
          </div>
        </div>
      }
    />
  );
}
